// extracted by mini-css-extract-plugin
module.exports = {"centering":"Overview-module__centering--1SPEw","heading":"Overview-module__heading--2_jcD"};